import React, {Component} from 'react';
import {Route} from 'react-router-dom';
import asyncComponent from './asyncComponent';

const HomeContainer = asyncComponent(() =>
    import('./containers/HomeContainer/HomeContainer')
);

const ContactUs = asyncComponent(() =>
    import('./containers/ContactUsContainer/ContactUsContainer')
);

class App extends Component {
    render() {
        return (
            <React.Fragment>
                <Route exact path="/" component={HomeContainer} />
                <Route path="/contact" component={ContactUs} />
            </React.Fragment>
        );
    }
}

export default App;
